import { useEffect } from "react";
import { useLocation } from "react-router-dom";
import { Nav } from "@/components/Nav";
import { Footer } from "@/components/Footer";
import SmoothScroll from "@/components/SmoothScroll";
import { LOGO_EMBLEM } from "@/data/albums";

export const Layout = ({ children }) => {
  const { pathname } = useLocation();

  useEffect(() => {
    window.scrollTo({ top: 0 });
    if (window.__lenis) window.__lenis.scrollTo(0, { immediate: true });
  }, [pathname]);

  return (
    <SmoothScroll>
      <div className="relative bg-[#050505] min-h-screen">
        <div className="grain-overlay" />
        <div className="vignette" />

        {/* spinning corner emblem */}
        <div className="fixed bottom-6 right-6 z-40 hidden md:block pointer-events-none">
          <img
            src={LOGO_EMBLEM}
            alt="emblem"
            className="w-14 h-14 object-contain opacity-50"
            style={{ filter: "invert(1) brightness(1.15) contrast(2.6)", mixBlendMode: "screen", animation: "spin 26s linear infinite" }}
          />
        </div>

        <Nav />
        <main>{children}</main>
        <Footer />
      </div>
      <style>{`@keyframes spin { from { transform: rotate(0deg);} to { transform: rotate(360deg);} }`}</style>
    </SmoothScroll>
  );
};
